import { useCallback, useMemo } from 'react';

import { useTracking } from '@change-corgi/core/react/tracking';

import { usePetitionDetailsPageData } from 'src/app/pages/petitionGamma/details/pageContext';

import type { NormalizedDecisionMaker } from '../../../../../shared/types';
import { useDebouncedScreenWidth } from '../useDebouncedScreenWidth';

import { getTextForScreenWidth } from './utils';

type Result = ModelHookResult<
	{
		isResponseLong: boolean;
		responseText: string | undefined;
		readMoreLink: string;
	},
	{ handleLinkClick: () => void }
>;

export function useDecisionMakerResponse(response: NormalizedDecisionMaker['response']): Result {
	const track = useTracking();
	const screenWidth = useDebouncedScreenWidth();

	const { text, isTextLong } = useMemo(() => {
		return getTextForScreenWidth(response, screenWidth);
	}, [response, screenWidth]);

	const {
		data: {
			petition: { slug },
		},
	} = usePetitionDetailsPageData();

	const handleLinkClick = useCallback(() => {
		void track('legislative_bodies_read_full_response_click');
	}, [track]);

	return {
		data: { isResponseLong: isTextLong, responseText: text, readMoreLink: `/p/${slug}/responses/${response?.id}` },
		actions: { handleLinkClick },
	};
}
